import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const twwSupport: ContentBlock<"module"> = {
  id: makeId("module-tww-support"),
  kind: "module",
  tags: ["her", "emotional", "post-cycle"],
  title: "Two-Week Wait Support",
  subtitle: "Guided emotional and practical support during the TWW",
  icon: "🫶",
  body: {
    duration: "14 days",
    category: "support",
    forWhom: "her",
    includes: [
      "Daily guided meditations and journaling prompts",
      "Symptom tracking without spiraling (curated guidance)",
      "Peer support group with others in the TWW",
      "When-to-test timeline and result interpretation",
      "Coping strategies for both outcomes",
    ],
    trackableMarkers: [
      {
        name: "Beta-hCG",
        expectedToChange: true,
        expectation:
          "Blood test at 9–11 days post-transfer (or 14 days post-IUI). The definitive answer.",
        retestInterval: "48 hours if positive (to confirm doubling)",
      },
    ],
    priceRange: { low: 99, high: 199 },
    currency: "USD",
    status: "coming-soon",
    steps: [
      {
        title: "Days 1–5",
        description:
          "Rest and recover. Focus on gentle movement, hydration, and stress management.",
      },
      {
        title: "Days 6–10",
        description:
          "The hardest stretch. Daily meditations and journaling prompts to stay grounded.",
      },
      {
        title: "Days 11–14",
        description:
          "Testing guidance and result interpretation. Support regardless of outcome.",
      },
    ],
  },
  sources: [
    {
      title:
        "Psychological interventions for infertile patients: a meta-analysis",
      journal: "Human Reproduction Update",
      year: 2020,
      evidenceLevel: "meta-analysis",
    },
  ],
};

registerBlock(twwSupport);
